import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Tr, Th, Td, Badge } from "@chakra-ui/react";

function ReviewedApp({
  student_id,
  date,
  name,
  business_name,
  loan_amount,
  status,
  loan_id
}) {
  const navigate = useNavigate();

  const statuses = {
    pending: { label: "Pending", color: "yellow" },
    approved: { label: "Approved", color: "green" },
    rejected: { label: "Rejected", color: "red" },
  };

  return (
    <Tr
      _hover={{ backgroundColor: "gray.100" }}
      cursor="pointer"
      onClick={() => navigate(`/business_loans/${student_id}/${loan_id}`)}
    >
      <Td>{student_id}</Td>
      <Td>{date?.split("T")[0]}</Td>
      <Td>{name}</Td>
      <Td>{business_name}</Td>
      <Td>{loan_amount}</Td>
      <Td>{status ? (
          <Badge colorScheme={statuses[status]?.color} p={2} m={0}>
            {statuses[status]?.label}
          </Badge>
        ) : (
          <Badge colorScheme="gray">N/A</Badge>
        )}</Td>

    </Tr>
  );
}

export default ReviewedApp;
